module.exports = __webpack_public_path__ + "static/media/apartment5.3c13b867.jpg";